import React from 'react';
import { useState, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import { Dropdown, Card } from "react-bootstrap";
import Pagination from 'react-bootstrap/Pagination';
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"
import JasonFile from "./formLangfields.json";
import axios from 'axios';
import { Loader, Placeholder } from 'rsuite';
import useRecorder from "../utils/useRecorder.js";
import { Link, useNavigate } from 'react-router-dom';
import { Microphone, Stop, SignOut, Pause, ArrowClockwise, Record } from 'phosphor-react';
import "rsuite/dist/rsuite.css";

function IndexingPage() {
    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(false);
    const [langCode, setLangCode] = useState();
    const [recorderName, setRecorderName] = useState();
    const [indexingData, setIndexingData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [token, setToken] = useState();
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [Role, SetRole] = useState();
    const [audioURL, isRecording, startRecording, stopRecording, pause, setPause, resume, setResume, setIsRecording, setReset] = useRecorder();

    useEffect(() => {
        let selectedLang = localStorage.getItem("legalLanguage");
        let tok = localStorage.getItem("legaltoken");
        setToken(tok)
        if (tok) {
            const usrRole = jwt_decode(tok).role;
            SetRole(usrRole);
        };
        let isLogin = localStorage.getItem("legalIsLogin");
        setIsLogin(isLogin);
        if (selectedLang) {
            setLangCode(selectedLang)
        } else
            setLangCode("en-IN")
    }, []);

    React.useEffect(() => {
        const fetchText = async () => {
            let fileName = `aud.wav`;
            let fd = new FormData();
            const output = await axios({ method: 'get', url: audioURL, responseType: 'blob' });
            let files = new File([output.data], fileName, { type: "audio/wav" });
            fd.append("file", files);
            fd.append("language", langCode)
            axios.post('https://voiceapi.aicte-india.org/voice-to-text', fd)
                .then(async res => {
                    const textResponse = res.data
                    if (recorderName == 'searchQuery') {
                        setSearchQuery(textResponse.data)
                    }
                })
        };
        if (audioURL !== undefined) {
            fetchText();
        }
    }, [audioURL]);

    const handleLogout = () => {
        localStorage.setItem("legalIsLogin", false);
        localStorage.removeItem("legaltoken");
        navigate("/lawdictionary");
    };

    const handleSearchQuery = (event) => {
        let data = event.target.value;
        if (langCode === 'en-IN' || langCode === null) {
            let newd = data.replace(/[&\/\\#,+()$;~%^@_.'":*?<>{}]/g, '');
            if (newd == ' ') {
                setSearchQuery('');
            } else {
                setSearchQuery(newd)
            }
        } else {
            setSearchQuery(data);
        }
    }

    const handleLogin = () => {
        navigate("/lawdictionary/login");
    };

    const handleUpdate = (data) => {
        localStorage.setItem("legalsearchQuery", data);
        navigate('/lawdictionary/list');
    };

    const handleFetchData = (val) => {
        setIsLoading(true);
        let formData = { selectedLanguage: "en-IN", character: val };
        axios.post(process.env.REACT_APP_BASE_URL + "fetch-indexing", formData)
            .then(function (response) {
                if (response.data.status === "success") {
                    let newData = response.data.response;
                    setIndexingData(newData);
                    let resp = [];
                    newData.map(it => {
                        resp.push(it[JasonFile[1][langCode]])
                    })
                    setFilteredData(resp);
                    setIsLoading(false);
                } else {
                    setIndexingData({});
                }
            });
    };

    const handleForm = () => {
        localStorage.setItem("legalsearchQuery", searchQuery);
        if (searchQuery !== '' && langCode !== '') {
            navigate('/lawdictionary/list');
        } else {
            alert('Language and Search Keyword not Empty')
        }
    };

    const HandleAddButton = () => {
        navigate("/lawdictionary/add-new");
    }

    const HandleReqApproval = () => {
        if (Role === 'user') {
            navigate("/lawdictionary/user-request-list");
        } else {
            navigate("/lawdictionary/request-list");
        }
    }

    // =========Pagination logic=========
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(50);
    const lastPostIndex = currentPage * postPerPage;
    const firstPostIndex = lastPostIndex - postPerPage;
    const c_post = filteredData.slice(firstPostIndex, lastPostIndex);
    const total_page = Math.ceil(filteredData.length / postPerPage);
    const page_arr = [...Array(total_page).keys()];
    // =========Pagination logic=========


    return (
        <>
            <div className="topDiv searchList">
                <header className="headerLst">
                    <div className="container mainSrchDiv">
                        <div className="mainSrchDivIn">
                            <div className="row align-items-center">
                                <div className="logoarea col-12 col-sm-12 col-md-12 col-lg-9">
                                    <div className="d-flex justify-content-start flex-wrap align-items-center">
                                        <div className="listLogo">
                                            <a href="https://anuvadini.aicte-india.org/">
                                                <img src={anu_logo} width="210px" />
                                            </a>
                                            <a>
                                                <img src={mlj} alt="" width="200px" style={{ marginLeft: 10 }} />
                                            </a>
                                            <a href="">
                                                <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120px" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                                    <div className="d-flex justify-content-end align-items-center phonecenter">
                                        <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => { navigate('/lawdictionary') }}>
                                            Home
                                        </button>
                                        <button className="feedbackSpn h-auto w-auto" style={{ height: 36, }} onClick={() => HandleAddButton()}>
                                            Add New Record
                                        </button>
                                        {isLogin == "true" ? (
                                            <>
                                                {Role === "validator" || Role === "admin" ? <>
                                                    <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => HandleReqApproval()}>
                                                        Approval Requests
                                                    </button>
                                                </> : <>
                                                    <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => HandleReqApproval()}>
                                                        Approval Requests
                                                    </button></>}
                                                <div className="d-flex justify-content-end buttonmargin">
                                                    <div className="wrapper signout">
                                                        <button className="button w-auto" onClick={() => handleLogout()}><b><SignOut size={32} /></b>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>) : (<>
                                                <div className="wrapper listLogin">
                                                    <button className="button w-auto" onClick={() => handleLogin()} > <b>Login</b></button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 col-xs-12 formSrchDivLst">
                                <div className="formSrchDiv" style={{ display: "flex" }}>
                                    <span className="slctLang">
                                        <Dropdown className="text-end">
                                            <Dropdown.Toggle className="selectmenu text-start p-relative w-auto" variant="success">
                                                {langCode ? JasonFile[0][langCode] : "Select Language"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {Object.entries(JasonFile[0]).map((res, i) => {
                                                    return (
                                                        <Dropdown.Item value={res[0]} onClick={(e) => { setLangCode(res[0]); setFilteredData([]); localStorage.setItem("legalLanguage", res[0]); }} key={i} >
                                                            {res[1]}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </span>
                                    <div className="formInputTxt">
                                        <input type="text" name="searchQuery" className="form-conrol form-control-home" placeholder="Search" value={searchQuery} onChange={(event) => handleSearchQuery(event)} />
                                        <span className="frmSrchIcn">
                                            <i className="fa fa-search" aria-hidden="true"></i>
                                        </span>
                                        <div className="fromGroup scheme new">
                                            {isRecording && recorderName == "searchQuery" ? (
                                                <React.Fragment>
                                                    <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording} >
                                                        <Stop size={20} weight="fill" />
                                                    </button>
                                                    {pause != false ? (
                                                        <>
                                                            <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true); }} >
                                                                <Record size={20} weight="fill" />
                                                            </button>
                                                            <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording} >
                                                                <ArrowClockwise size={20} weight="bold" />
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button className="stopbutton startbutton" onClick={() => { setPause(true); }} >
                                                                <Pause size={20} weight="fill" />
                                                            </button>
                                                            {Text ? (
                                                                <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording} >
                                                                    <ArrowClockwise size={20} />
                                                                </button>
                                                            ) : ("")}
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            ) : (
                                                <button className="startbutton" onClick={(e) => { setRecorderName("searchQuery"); startRecording(); }} disabled={isRecording} >
                                                    <Microphone size={20} weight="fill" />
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="sbmtBtnDiv">
                                        <button type="submit" className="srchBtnHm" onClick={() => { handleForm() }} >
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div className='searchList'>
                    <Card className='cardbg p-4 mt-3'>
                        <Card.Body>
                            <ul className='d-flex justify-content-between tablist flex-wrap'>
                                {langCode && JasonFile[8]["en-IN"].map((res) => (
                                    <li>
                                        <Link onClick={() => { handleFetchData(res) }}>{res}</Link>
                                    </li>
                                ))}
                            </ul>
                        </Card.Body>
                    </Card>
                </div>

                <section className="searchListSec">
                    {isLoading === true ? <>
                        <div className='text-center'>
                            <Placeholder.Paragraph rows={8} />
                            <Loader backdrop content="loading..." vertical />
                        </div>
                    </> : <>
                        <div className='container'>
                            <ul>
                                {filteredData && c_post.map((res, i) =>
                                    (<li onClick={(e) => { handleUpdate(res) }} key={i}>{res}</li>)
                                )}

                                {filteredData ? (
                                    <div className="d-flex justify-content-center">
                                        <Pagination>
                                            {page_arr.map((i, x) => (
                                                <Pagination.Item key={i} onClick={() => {
                                                    setCurrentPage(i + 1);
                                                }}
                                                    active={i + 1 === currentPage}>
                                                    {i + 1}
                                                </Pagination.Item>
                                            ))}
                                        </Pagination>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </ul>
                        </div>
                    </>}
                </section>
            </div>
        </>
    )
}

export default IndexingPage;